import { render, staticRenderFns } from "./PrivateAccount.vue?vue&type=template&id=10f87ee4&scoped=true&"
import script from "./PrivateAccount.vue?vue&type=script&lang=js&"
export * from "./PrivateAccount.vue?vue&type=script&lang=js&"
import style0 from "./PrivateAccount.vue?vue&type=style&index=0&id=10f87ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f87ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f87ee4')) {
      api.createRecord('10f87ee4', component.options)
    } else {
      api.reload('10f87ee4', component.options)
    }
    module.hot.accept("./PrivateAccount.vue?vue&type=template&id=10f87ee4&scoped=true&", function () {
      api.rerender('10f87ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateAccount.vue"
export default component.exports